import { useEffect } from 'react';

import {
  useSessionTokensActions
} from './SessionTokensContext';

import {
  getSessionTokens,
} from './restApi';

const SessionTokensLoader = () => {
  const { initializeState, onResponse, onError } = useSessionTokensActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getSessionTokens({
      onResponse,
      onError,
      pageNumber: 1,
    });
  }, []);

  return null;
};

export default SessionTokensLoader;
